import $ from 'jquery';
import SessionManager from '../routes/SessionManager';

export default class AppConfig {
  static config = {
    google_analytics: {
      measurement_id: {
        prod: 'G-F935M4WR06',
        stage: 'G-N8ZH8ZMT8X',
        qa: 'G-N8ZH8ZMT8X',
        dev: 'G-N8ZH8ZMT8X'
      }
    }
  };

  static loading = {

  };

  static getGoogleAnalyticsId = () => {
    let host = document.location.host;
    let env = (host === 'www.sitesupt.com:8442' || host === 'localhost:3000') ? 'dev' :
      host === 'www.sitesupt.com:8443' ? 'qa' :
        host === 'www.sitesupt.com:8444' ? 'stage' : 'prod';

    console.log('HOST: ' + host.toLowerCase() + ', ENV: ' + env.toUpperCase());
    return AppConfig.config.google_analytics.measurement_id[env];
  }

  static getConfig = (config_type, config_key) => {
    const sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    if (!user)
      return;

    var data = {
      user_login: user.user_login,
      user_token: user.user_token,
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      config_key
    }
    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/sitesupt-config/' + config_type,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        async: false
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          if (res.data && res.data[config_key]) {
            AppConfig.config[config_key] = res.data[config_key];
            delete AppConfig.loading[config_key];
          }
        }
      },
      (res) => {
      });
  }

  static getConfigParameter = (config_type, config_key) => {
    if (!AppConfig.config[config_key] && !AppConfig.loading[config_key]) {
      AppConfig.loading[config_key] = true;
      AppConfig.getConfig(config_type, config_key);
      return null;
    }
    return AppConfig.config[config_key];
  }
}